import { authHeader, handleResponse } from '../helpers';
export const CreateTargetService ={
GetRegionDll,
getStateDDL,
getDistrictDDL,
getTownDDL,
getAllProductList,
CreateProductTarget,
CreateCategoryTarget,
getCategoryDDL,
getProductTargetData,
getCategoryTargetData

};

function GetRegionDll() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(`${process.env.REACT_APP_API_URL}UserDMaster/GetRegion`, requestOptions)
    .then(handleResponse)
    .then(data => {
      if (data.ResponseCode !== "200") {
        throw new Error(data.ResponseMessage || "Failed to fetch regions");
      }
      return data;
    });
}

function getStateDDL(regionId) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(`${process.env.REACT_APP_API_URL}UserDMaster/GetAllState?regionIds=${regionId}`, requestOptions)
    .then(handleResponse)
    .then(data => {
      if (data.ResponseCode !== "200") {
        throw new Error(data.ResponseMessage || "Failed to fetch states");
      }
      return data;
    });
}
function getDistrictDDL(regionId) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(`${process.env.REACT_APP_API_URL}UserDMaster/GetAllDistrict?stateId=${regionId}`, requestOptions)
    .then(handleResponse)
    .then(data => {
      if (data.ResponseCode !== "200") {
        throw new Error(data.ResponseMessage || "Failed to fetch states");
      }
      return data;
    });
}

 function getTownDDL(districtId) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(`${process.env.REACT_APP_API_URL}UserDMaster/GetAllTown?distuctId=${districtId}`, requestOptions)
    .then(handleResponse)
    .then(data => {
      if (data.ResponseCode !== "200") {
        throw new Error(data.ResponseMessage || "Failed to fetch states");
      }
      return data;
    });
}
function getAllProductList() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(`${process.env.REACT_APP_API_URL}UserDMaster/GetProductNameList`, requestOptions)
    .then(handleResponse)
    .then(data => {
      if (data.ResponseCode !== "200") {
        throw new Error(data.ResponseMessage || "Failed to fetch states");
      }
      return data;
    });
}
export function CreateProductTarget(districtData) {
  const requestOptions = {
    method: 'POST',
    headers: {
      ...authHeader(),
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(districtData)
  };

  return fetch(`${process.env.REACT_APP_API_URL}SalesData/CreateProductTarget`, requestOptions)
    .then(handleResponse)
    .catch(error => {
      console.error("CreateProductTarget error:", error);
      throw error;
    });
}
 function CreateCategoryTarget(districtData) {
  const requestOptions = {
    method: 'POST',
    headers: {
      ...authHeader(),
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(districtData)
  };

  return fetch(`${process.env.REACT_APP_API_URL}SalesData/CreateCategoryTarget`, requestOptions)
    .then(handleResponse)
    .catch(error => {
      console.error("CreateCategoryTarget error:", error);
      throw error;
    });
}
function getCategoryDDL() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(`${process.env.REACT_APP_API_URL}UserDMaster/GetAllCategory`, requestOptions)
    .then(handleResponse)
    .then(data => {
      if (data.ResponseCode !== "200") {
        throw new Error(data.ResponseMessage || "Failed to fetch regions");
      }
      return data;
    });
}
function getProductTargetData(requestParam) {
    const requestOptions = {
        method:'Post',
        headers:{
             ...authHeader(),
      'Content-Type': 'application/json'
        },
         body: JSON.stringify(requestParam)
    }
    return fetch(`${process.env.REACT_APP_API_URL}SalesData/ProductTargetData`,requestOptions)
    .then(handleResponse)
    .then(data => {
      if (data.ResponseCode !== "200") {
        throw new Error(data.ResponseMessage || "Failed to fetch regions");
      }
      return data;
    });
}
function getCategoryTargetData(requestParam) {
    const requestOptions = {
        method:'Post',
        headers:{
             ...authHeader(),
      'Content-Type': 'application/json'
        },
         body: JSON.stringify(requestParam)
    }
    return fetch(`${process.env.REACT_APP_API_URL}SalesData/CategoryTargetData`,requestOptions)
    .then(handleResponse)
    .then(data => {
      if (data.ResponseCode !== "200") {
        throw new Error(data.ResponseMessage || "Failed to fetch regions");
      }
      return data;
    });
}

 
 

 
 


 
 
 
 
 

 
 
